<template>

    <!-- 头部 -->
    <div class="proConHead">
        <div class="box">
            <div class="headle">
                <div class="logo">
                    <el-image @click="Shouye" fit="contain" class="" :src="require('@/assets/pc/proComSystem/logo.png')" alt="" />
                </div>
                <!-- <div class="luang"> -->
					<!-- @command="yuyandian" -->
                    <!-- <el-dropdown placement="bottom" >
                        <span class="el-dropdown-link tit-16 montserRegular" style="color: #333; margin: 0;">
                            <i class="iconfont icon-diqiu tit-16"></i>
                            <em>{{yuyancode}}</em>
                            <i class="iconfont icon-jiantou1"></i>
                        </span>
                       <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item, index) in language" :key="index">{{ item.name
                                }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                <!-- </div> -->
            </div>

            <div class="headre" @click.stop="$router.back()">
                <i>
                    <svg class="icon" viewBox="0 0 1024 1024" version="1.1" width="20" height="20">
                        <path
                            d="M622.650611 284.901749 447.745069 284.901749 447.745069 142.823869 63.980685 334.705038l383.76336 191.882192L447.744046 384.834762l189.391465 0c149.914358 0 224.855164 62.789045 224.855164 188.368158 0 129.928165-77.435627 194.876386-232.338602 194.876386L187.952184 768.079306l0 99.93199L634.146433 868.011296c211.184817 0 316.777737-95.104031 316.777737-285.311071C950.924169 384.178823 841.510224 284.901749 622.650611 284.901749z"
                            fill="#E60012"></path>
                    </svg>
                </i>
                <span>{{gudingziduan.xinzengde.Back}}</span>
            </div>
        </div>
    </div>
    <!-- 头部 end!!-->

</template>
<script>
export default {
    data() {
        return {
			gudingziduan: {},
			yuyancode:'EN',
            language: [{ name: 'English', url: '', k: 'EN' }, { name: 'Português-Brazil', url: '', k: 'PT' }, { name: 'English-Pakistan', url: '', k: 'PK' },{ name: 'Türkçe', url: '', k: 'TN' }],
		}
    },
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
	        this.gudingziduan=this.$store.state.cunyuanyan
			console.log(this.gudingziduan,'video')
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	},
    created() {
		this.yuyancode=this.$store.state.yuyan
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
    },
    computed: {
    },
    methods: {
		Shouye() {
			this.$router.push('/')
		},
		
		yuyandian(e) {
			this.yuyancode=e
			// console.log(e,'yuyandian')
			this.$store.commit('Gaiyuyan', e);
			setTimeout(() => {
				// console.log(this.$store.state.cunyuanyan)
				this.gudingziduan=this.$store.state.cunyuanyan
			}, 600)
		}
    },
}
</script>
<style lang="scss" scoped>
* {
    line-height: 1;
}
	
// 头部
.proConHead {
    position: fixed;
    top: 0;
    width: 100%;
    padding: 10px 2%;
    box-sizing: border-box;
    z-index: 9;

    .box {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    // 头部左侧
    .headle {
        display: flex;
        align-items: center;

        .logo {
            margin-right: .3rem;

            .el-image {
                width: 2.61rem;
                height: 0.4rem;
            }
        }
    }

    // 右侧
    .headre {
        cursor: pointer;
        display: flex;
        align-items: center;

        span {
            font-family: "montserRegular";
            margin-left: .1rem;
        }
    }

    // 语言
    .luang {
        padding: .14rem .18rem;
        background: #f8f8f8;
        border: 1px solid #cfcfcf;
        border-radius: 50px;

        .el-dropdown-link {
            display: flex;
            align-items: center;
            color: #000000;

            em {
                margin: 0 8px;
            }

            i {
                opacity: .3;
            }

            i.icon-jiantou1 {
                font-size: 11px;
            }
        }
    }
}

// 语言下拉样式修改
.el-dropdown-menu__item{padding: 0 20px;line-height: 36px;}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
    color: #fff;
    background: rgba(231, 10, 22, 1);
}
</style>
